import React, { useState } from 'react';
import { Select } from 'app/components';
import TermsAndConditions from './termsAndConditions';
import PrimaryTerms from './primaryTerms';

const TermsWrapper = () => {
  const [selected, setSelected] = useState('Primary Ticketing');

  return (
    <div className='pt-8 pb-16 lg:pt-16 lg:pb-24 bg-white terms-of-service'>
    <div className='flex flex-justify-between px-6 mx-auto max-w-screen-xl'>
    <div className='flex flex-col gap-12 mx-auto w-full max-w-2xl'>
      <div className='flex gap-2 items-center justify-center w-full mt-20'>
        <Select
          label='Primary Ticketing'
          width={250}
          onClick={() => setSelected('Primary Ticketing')}
          selected={selected === 'Primary Ticketing'}
        />
        <Select
          label="Free Resale"
          width={250}
          onClick={() => setSelected('Free Resale')}
          selected={selected === 'Free Resale'}
        />
      </div>
      {selected === 'Free resale' ? (
        <TermsAndConditions />
      ) : (
        <PrimaryTerms />
      )}
    </div>
    </div>
    </div>
  );
};

export default TermsWrapper;
